// import { useLazyQuery } from "@apollo/client";
import { DogHistory } from "container/DogHistory";
import MakePaymentForUnPaid from "container/MakePaymentForUnPaid";
import { MemberDashboard } from "container/MemberDashboard";
import { MyProfile } from "container/MyProfile";
import { LoaderProvider } from "container/MyProfile/Context/EditAndLoaderContext";
import RegisterDogInternal from "container/RegisterDogInternal";
import { TrialCalendar } from "container/TrialCalendar/Screens/TrialList";
import { TrialDetails } from "container/TrialCalendar";
import { TrialResult } from "container/TrialResults";
import TrialResultDetails from "container/TrialResults/Components/TrialResultDetails";
import { RoleContext } from "context/RoleContext";
import { useContext, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { MobileHeader } from "shared/Components/mobileHeader";
import { SideNav } from "shared/Components/sidenav";
import { useDispatch } from 'react-redux';
import { ViewEntries } from "container/MemberDashboard/Components/ViewEntries";
export const DashboardRoutes = () => {
  // const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const { pathname } = useLocation();
  const role = useContext(RoleContext);



  // alert(role)

  const NavBar = () => {
    if (
      pathname === "/dashboard/registerDog" ||
      pathname === "/dashboard/makePayment"
    ) {
      return <></>;
    }
    return !isMobile && !isTablet ? <SideNav /> : <MobileHeader />;
  };

  return (
    <div className="p-3 bg-100 w-full">
      <NavBar />
      <Routes>
        <Route path="/memberDashboard/*" element={<MemberDashboard />} />
        <Route path="/registerDog/*" element={<RegisterDogInternal />} />
        {/* <Route path="/makePayment" element={<MakePaymentForUnPaid />} /> */}
        <Route path="/makePayment" element={<MakePaymentForUnPaid />} />
        <Route path="/trialCalendar" element={<TrialCalendar />} />
        <Route path="/trialDetails/:id/*" element={<TrialDetails />} />
        <Route path="/trialResults/*" element={<TrialResult />} />
        <Route path="/viewEntries" element={<ViewEntries />} />
        {/* <Route path="/trialResults/:id/*" element={<TrialResultDetails />} /> */}
        <Route
          path="/trialResults/:id/*"
          element={<TrialResultDetails isUpload isMember />}
        />
        <Route path="/switchRole" element={<MyProfile />} />
        {/* <Route path="/trialResults/:id" element={<TrialResultDetails />} /> */}
        <Route path="/dogHistory/*" element={<DogHistory />} />
        <Route
          path="/myProfile/*"
          element={
            <LoaderProvider>
              <MyProfile />
            </LoaderProvider>
          }
        />
        <Route
          path="/"
          element={<Navigate to="/dashboard/memberDashboard" replace />}
        />
        <Route
          path="*"
          element={<Navigate to="/dashboard/memberDashboard" replace />}
        />
      </Routes>
    </div>
  );
};
